<script lang='ts' setup>
</script>
<template>
  <div class="loading-bar">
    <div class="loading-bar-container">
      <span class="loading-bar-title">Loading Encoder</span>
      <q-linear-progress class = "linear-progress" size="4px" indeterminate rounded style="color: #008394; background: #DCE4E9;"></q-linear-progress>
      <span class="loading-bar-title">This may take up to 10 seconds to load</span>
    </div>
  </div>
</template>
<style lang="scss">
@import '../../css/iodine.variables';
.loading-bar {
  display: grid;
  place-items: center;
  height: 100%;
  width: 100%;
}
.loading-bar-container {
  text-align: center;
}
.loading-bar-title {
  color: var($iodine-light-on-surface, #111414);
  font-family: $iodine-font-family;
  font-size: $iodine-label-large;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
}
.loading-bar-label {
  color: var($iodine-light-on-surface-variant, #111414);
  font-family: $iodine-font-family;
  font-size: $iodine-label-medium;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
}
.linear-progress {
  display: flex;
  width: 400px;
  align-items: center;
  gap: 4px;
  margin: 16px;
}

</style>
